import React, { useState } from 'react';
import { Form, Input, InputNumber, DatePicker, Select, Button, Card, message, Space } from 'antd';
import { useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { createCreditProduct } from '../../graphql/mutation';
import './CreditProducts.css';
import moment from 'moment';

const { Option } = Select;

const CreateCreditProduct = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [createProduct] = useMutation(createCreditProduct, {
    onCompleted: (data) => {
      message.success('Credit product created successfully!');
      navigate('/credit-products');
    },
    onError: (error) => {
      message.error(`Error creating credit product: ${error.message}`);
      setLoading(false);
    },
  });

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const input = {
        name: values.name,
        amount: values.amount,
        startDate: moment(),
        endDate: moment().add(5, 'years'),
        limit: values.limit,
        price: values.price,
        type: values.type,
      };

      await createProduct({
        variables: { input },
      });
    } catch (error) {
      console.error('Error creating credit product:', error);
    }
  };

  const productTypes = [
    { value: 'YEARLY', label: 'Yearly' },
    { value: 'WEEKLY', label: 'Weekly' },
    { value: 'MONTHLY', label: 'Monthly' },
    { value: 'INSTANT', label: 'Instant' },
    { value: 'TIER1', label: 'Tier 1' },
    { value: 'TIER2', label: 'Tier 2' },
    { value: 'TIER3', label: 'Tier 3' },
    { value: 'LIFETIME', label: 'Lifetime' },
    { value: 'ONE_TIME', label: 'One Time' },
    { value: 'PROMO', label: 'Promo' },
  ];

  return (
    <div className="credit-products-container">
      <Card title="Create Credit Product">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{
            limit: 0,
            price: 0,
            amount: 0,
          }}
        >
          <Form.Item
            name="name"
            label="Product Name"
            rules={[{ required: true, message: 'Please enter a product name' }]}
          >
            <Input placeholder="Enter product name" />
          </Form.Item>

          <Form.Item
            name="type"
            label="Product Type"
            rules={[{ required: true, message: 'Please select a product type' }]}
          >
            <Select placeholder="Select product type">
              {productTypes.map((type) => (
                <Option key={type.value} value={type.value}>
                  {type.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="amount"
            label="Credit Amount"
            rules={[{ required: true, message: 'Please enter credit amount' }]}
          >
            <InputNumber
              min={0}
              style={{ width: '100%' }}
              placeholder="Enter credit amount"
            />
          </Form.Item>

          <Form.Item
            name="price"
            label="Price (USD)"
            rules={[{ required: true, message: 'Please enter price' }]}
          >
            <InputNumber
              min={0}
              step={0.01}
              style={{ width: '100%' }}
              placeholder="Enter price in USD"
            />
          </Form.Item>

          <Form.Item
            name="limit"
            label="Usage Limit"
            rules={[{ required: true, message: 'Please enter usage limit' }]}
          >
            <InputNumber
              min={0}
              style={{ width: '100%' }}
              placeholder="Enter usage limit (0 for unlimited)"
            />
          </Form.Item>

{/*           <Form.Item
            name="startDate"
            label="Start Date"
            rules={[{ required: true, message: 'Please select start date' }]}
          >
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>

          <Form.Item
            name="endDate"
            label="End Date"
            rules={[{ required: true, message: 'Please select end date' }]}
          >
            <DatePicker style={{ width: '100%' }} />
          </Form.Item> */}

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit" loading={loading}>
                Create Product
              </Button>
              <Button onClick={() => navigate('/credit-products')}>
                Cancel
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default CreateCreditProduct; 